document.querySelectorAll('.swatch-wrapper').forEach(function(swatch) {
    swatch.addEventListener('click', function(event) {
        event.preventDefault();
        var imgUrl = this.getAttribute('data-variant-image');
        var variantId = this.getAttribute('data-variant-id');
        var productId = this.closest('.card-product').getAttribute('data-product-id');
        var swatchLink = this.getAttribute('href');
        var imgElement = document.getElementById('card-product-image-' + productId);
        var productCard = this.closest('.card-product');
        
        console.log('VariantId:', variantId);
        
        // Korrekte Art, das Input-Element zu finden und die Varianten-ID zu setzen
        if (productCard && variantId) {
            var variantInput = productCard.querySelector('.product-variant-id');
            if (variantInput) {
                variantInput.value = variantId;
                console.log('Updated variant input to:', variantId);
            }
        }
        
        // Update product link
        if (productCard && swatchLink) {
            var productLink = productCard.querySelector('.card-product-link');
            if (productLink) {
                productLink.setAttribute('href', swatchLink);
            }
        }
        
        // Update product image
        if (imgUrl && imgElement) {
            imgElement.src = imgUrl;
        }
    });
});